import {
  AcceptAsesor,
  AcceptCoordinador,
  AcceptLiberarEstancia,
  CancelEstancia,
  EditEstancia,
  GenerateCartaCompromisoAsesor,
  RegistrarResultadoRevisionInicial,
  RejectEstancia,
} from '@/typings/estancia';
import { validateHttpResponse } from '@/utils';
import httpJson from './http-json';
import httpMultipart from './http-multipart';

class EstanciaRepository {
  path: string;
  constructor() {
    this.path = 'Estancia/';
  }

  async getGenerateCartaCompromisoAsesor(data: GenerateCartaCompromisoAsesor) {
    try {
      const response = await httpMultipart.put(
        `${this.path}Generar_carta_compromiso_asesor`,
        data
      );
      return validateHttpResponse(response);
    } catch (e: any) {
      return validateHttpResponse(e.response);
    }
  }

  async getGenerateCartaAceptacion(id: BigInteger, idMinuta: string) {
    try {
      const response = await httpJson.get(
        `${this.path}Generar_carta_aceptacion/${id}/${idMinuta}`
      );
      return validateHttpResponse(response);
    } catch (e: any) {
      return validateHttpResponse(e.response);
    }
  }

  async getGenerateCartaLiberacion(id: BigInteger, idMinuta: string) {
    try {
      const response = await httpJson.get(
        `${this.path}Generar_carta_liberacion/${id}/${idMinuta}`
      );
      return validateHttpResponse(response);
    } catch (e: any) {
      return validateHttpResponse(e.response);
    }
  }

  async getObtenerLista() {
    try {
      const response = await httpJson.get(`${this.path}Obtener_lista`);
      return validateHttpResponse(response);
    } catch (e: any) {
      return validateHttpResponse(e.response);
    }
  }

  async getObtenerEstancia(id: number) {
    try {
      const response = await httpJson.get(`${this.path}Obtener_estancia/${id}`);
      return validateHttpResponse(response);
    } catch (e: any) {
      return validateHttpResponse(e.response);
    }
  }

  async putAceptarAsesor(data: AcceptAsesor) {
    try {
      const response = await httpMultipart.put(
        `${this.path}Aceptar_asesor`,
        data
      );
      return validateHttpResponse(response);
    } catch (e: any) {
      return validateHttpResponse(e.response);
    }
  }

  async putAceptarCoordinador(data: AcceptCoordinador) {
    try {
      const response = await httpMultipart.put(
        `${this.path}Aceptar_coordinador`,
        data
      );
      return validateHttpResponse(response);
    } catch (e: any) {
      return validateHttpResponse(e.response);
    }
  }

  async putLiberarEstancia(data: AcceptLiberarEstancia) {
    try {
      const response = await httpMultipart.put(
        `${this.path}Liberar_estancia`,
        data
      );
      return validateHttpResponse(response);
    } catch (e: any) {
      return validateHttpResponse(e.response);
    }
  }

  async putEditar(data: EditEstancia) {
    try {
      const response = await httpJson.put(`${this.path}Editar`, data);
      return validateHttpResponse(response);
    } catch (e: any) {
      return validateHttpResponse(e.response);
    }
  }

  async putSolicitarLiberacion(id: BigInteger) {
    try {
      const response = await httpJson.put(
        `${this.path}Solicitar_liberacion/${id}`
      );
      return validateHttpResponse(response);
    } catch (e: any) {
      return validateHttpResponse(e.response);
    }
  }

  async putCancelar(data: CancelEstancia) {
    try {
      const response = await httpJson.put(`${this.path}Cancelar`, data);
      return validateHttpResponse(response);
    } catch (e: any) {
      return validateHttpResponse(e.response);
    }
  }

  async putRechazar(data: RejectEstancia) {
    try {
      const response = await httpJson.put(`${this.path}Rechazar`, data);
      return validateHttpResponse(response);
    } catch (e: any) {
      return validateHttpResponse(e.response);
    }
  }

  async putRegistrarResultadoRevisionInicial(
    data: RegistrarResultadoRevisionInicial
  ) {
    try {
      const response = await httpMultipart.put(
        `${this.path}Registrar_resultado_revision_inicial`,
        data
      );
      return validateHttpResponse(response);
    } catch (e: any) {
      return validateHttpResponse(e.response);
    }
  }
}

export default new EstanciaRepository();
